export const STAFF = "staff";
export const SIGNED_IN_USERS = "signed_in_users";
export const USER_TYPES = [STAFF, SIGNED_IN_USERS];

export const USER_TYPE_NAME = {
  [STAFF]: "knowledge-user-segments.userSegment.staffUserType",
  [SIGNED_IN_USERS]:
    "knowledge-user-segments.userSegment.signedInUsersUserType",
};

export const CREATE_STEP_SETUP = "setup";
export const CREATE_STEP_SEGMENT = "segment";
export const CREATE_STEP_REVIEW = "review";
export const CREATE_STEPS = [
  CREATE_STEP_SETUP,
  CREATE_STEP_SEGMENT,
  CREATE_STEP_REVIEW,
];



// WEBPACK FOOTER //
// ./src/constants.js